module.exports = __webpack_public_path__ + "img/Group 125@2x.fbd4b550.png";